import React from "react";
import Modal from "components/common/controls/modal/Modal";

interface Props {
  children: React.ReactChild;
  title: string;
  onClose: () => void;
}

export default function TokenEditorModal(props: Props) {
  const { title, children, onClose } = props;
  return (
    <Modal
      title={title}
      visible={true}
      onClose={onClose}
      width="471px"
      height="auto"
      displayDefaultActions={false}
    >
      {children}
    </Modal>
  );
}
